import React, { Component } from 'react'
import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from 'react-intl';
import { Tabs } from 'antd';
import axios from 'axios'

import LoadingControl from './Loading';
import { SERVERS_PATH } from '../utils/constants';
import { TrimNan, getCurrencySymbol, formatBytes } from '../utils/utils';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import ReportsFilter from './ReportsFilter';
import ServerReportGeneral from './ServerReportGeneral';
import DetailedReport from './DetailedReport';
import { getServerDetailedColumns } from './GetDetailedColumns';
import BreadcrumbHeader from './BreadcrumbHeader'

class ServerReport extends Component {

    constructor (props) {
        super(props);

        this.serverId = TrimNan(parseInt(this.props.params['id'], 10));
        this.serverName = "";
        this.daysNumber = null;

        this.state = {
            error: null,
            isLoaded: false,
            server: null
          };
    }

    async getData() {

        var url = ApplyFilterParams("/server/" + this.serverId + "?doNotReturnEmptyObjects=false", this.props.filterData);
        
        const res = await axios(url);
        return res.data;
        }

    update() {
        this.setState({isLoaded: false});
    
        this.getData()
        .then(res => {
            this.setState({ error: null, isLoaded: true, server: this.getColumns(res) });
        })
        .catch(err => {
            console.log(err);
            this.setState( {error: err, isLoaded: false, server: null });
        });
        }  
        
    componentDidMount() {
        if (this.serverId <= 0)
        {
            this.setState( {error: {message : "Bad server id"}});
        }
        else
        {
            this.update();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterData !== this.props.filterData) {
            this.update();
        }
    }

    getColumns(res)
    {
        const lang = navigator.language || navigator.userLanguage;

        var data = [];
        if ((res instanceof Array) && res.length > 0)
        {
            data = data = res[0];
        }

        this.serverName = data.srvName;

        let dateMin = new Date(data.minDate);
        let dateMax = new Date(data.maxDate);

        let reportPeriod = "";
        if (isNaN(dateMin) || isNaN(dateMax))
        {
            this.daysNumber = null;
        }
        else
        {
            this.daysNumber = Math.round(dateMax.getTime() - dateMin.getTime()) / (1000 * 60 * 60 * 24);

           reportPeriod = dateMin.toLocaleDateString(lang) + ' - ' + 
                    dateMax.toLocaleDateString(lang);

        }

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        var columns = [
            {
                title :  <FormattedMessage id="Server"/>,
                data : data.srvName,
            },
            {
                title : "Version",
                data : data.version,
            },
            {
                title : <FormattedMessage id="LastALive"/>,
                data : data.lastAlive === undefined ? "" : new Date(data.lastAlive).toLocaleString(lang),
            },
            {
                title : <FormattedMessage id="Users"/>,
                data : data.users,
                link: "/users?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Printers"/>,
                data : data.printers,
                link: "/printers?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Computers"/>,
                data : data.computers,
                link: "/computers?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Documents"/>,
                data : data.documents,
                link: "/documents?serverId=" + this.serverId,
            },
            {
                title : <FormattedMessage id="Pages"/>,
                data : data.pages,
            },
            {
                title : <FormattedMessage id="Cost"/>,
                data : currencyFormatter.format(data.cost === undefined ? 0 : data.cost),
            },
            {
                title : <FormattedMessage id="JobDataSize"/>,
                data : formatBytes(data.jobDataSize === undefined ? 0 : data.jobDataSize),
            },
            {
                title : <FormattedMessage id="ReportPeriod"/>,
                data : reportPeriod,
            },
        ];

        return columns;
    }

    render(){

        if(this.state.error != null)
        {
            return (
                <div>
                    <h3>{this.state.error.message}</h3>
                    <Link to={SERVERS_PATH}><FormattedMessage id="Back"/></Link>
                </div>
            );
        }
        else if (!this.state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {           
            if (this.state.server === null)
            {
                return ( 
                    <div>
                        <FormattedMessage id="ObjectNotFound"/>
                        <Link to={SERVERS_PATH}><FormattedMessage id="Back"/></Link>
                    </div>
                );
            }
            
            const serverId = TrimNan(parseInt(this.props.params['id'], 10));

            return (
            <div>
                <div className = "filter-report-picker">
                    <ReportsFilter/>
                </div>
                <BreadcrumbHeader
                    location = {this.props.location}
                    objectLink = {this.serverName}
                    rootPath = {SERVERS_PATH}
                    pathName = "Server"
                />
                <br/>
                <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab={this.props.intl.formatMessage({ id: "LeftMenu.Submenu.general" })} key="1">
                        <ServerReportGeneral params={this.props.params} filterData = {this.props.filterData}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={this.props.intl.formatMessage({ id: "Detailed" })} key="2">
                        <DetailedReport 
                            api_url = {"/printer_summary?doNotReturnEmptyObjects=true&groupBy=true&serverId=" + serverId} 
                            columns = {getServerDetailedColumns()}
                            filterData = {this.props.filterData}
                        />
                    </Tabs.TabPane>
                </Tabs>
                <Link to={SERVERS_PATH}><FormattedMessage id="Back"/></Link>
            </div>
        )
    }
  }
}
function ServerReportRouter() {
    let params = useParams();
    let location = useLocation();
    let filterData = useSelector(state => state.reportFilter);
    let intl = useIntl();
    return <ServerReport params={params} location = {location} filterData = {filterData} intl={intl}/>
  }
 
export default ServerReportRouter;